<template>
  <div @click="handleClick" class="desc-icon">
    <img :src="activityInfo.mapStyle.fnModule.activityDesc.buttonImg" alt="" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DescIcon',
  computed: {
    ...mapGetters('activityInfo', ['activityInfo'])
  },
  methods: {
    handleClick() {
      this.$router.push({ path: '/descPage', query: { id: this.$route.query.id } })
    }
  },
}
</script>
<style lang="scss" scoped>
.desc-icon {
  width: 1.06rem;
  height: 1.06rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 1.06rem;
    display: inline-block;
  }
}
</style>
